import { TFeature } from '../../types/map';
import { TThunkAction } from '../../types/redux';
import { setMapOffer } from '../setMapOffer/setMapOffer';
import { markAsViewed } from '../viewed/markAsViewed';

export interface IOpenOfferPreviewDeps {
  isDetailed: boolean;
  precision: number;
}

export function openOfferPreview(
  feature: TFeature,
  { isDetailed, precision }: IOpenOfferPreviewDeps,
): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, context) => {
    const [offer] = feature.properties.offers;

    if (!offer?.realtyId) {
      context.logger.error('Не найден realtyId для открытия preview объявления', {
        domain: 'actions/features/openOfferPreview',
        featureId: feature.id,
      });

      return;
    }

    dispatch(setMapOffer({ realtyId: offer.realtyId, feature: { ...feature, precision } }));

    if (!offer.isViewed && offer.cianId) {
      await dispatch(markAsViewed({ feature, offerId: offer.cianId, precision, isDetailed }));
    }
  };
}
